import {produce} from 'immer';
import {  } from './actions';
import { deleteDefinition } from 'state/grid/util';
import {
  RECEIVE_SECURITY_ATTRIBUTE_OPTIONS,
  RECEIVE_SECURITY_ATTRIBUTES_DATA,
  REQUEST_SECURITY_ATTRIBUTE_OPTIONS,
  REQUEST_SECURITY_ATTRIBUTES_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
  DELETE_DEFINITION,
} from './actions';
import {COMMIT_SELECTIONS} from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: []
  },
  fetchingSecurityAttributesData: false,
  securityAttributesData: null,
  fetchingSecurityAttributesOptions: false,
  securityAttributesOptions: null,
};


export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const {definition, idx} = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }

    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.analyticsData = defaultState.analyticsData;
      state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_SECURITY_ATTRIBUTES_DATA: {
      state.fetchingSecurityAttributesData = true;
      state.securityAttributesData = defaultState.securityAttributesData;
      break;
    }
    case RECEIVE_SECURITY_ATTRIBUTES_DATA: {
      state.fetchingSecurityAttributesData = false;
      state.securityAttributesData = action.data;
      break;
    }
    case REQUEST_SECURITY_ATTRIBUTE_OPTIONS: {
      state.fetchingSecurityAttributesOptions = true;
      state.securityAttributesOptions = defaultState.securityAttributesOptions;
      break;
    }
    case RECEIVE_SECURITY_ATTRIBUTE_OPTIONS: {
      state.fetchingSecurityAttributesOptions = false;
      state.securityAttributesOptions = action.data;
      break;
    }
    default:
      return state;
  }
});
